import React, { useEffect, useReducer } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PageTitleContainer from '../common/PageTitleContainer';
import TablePagination from '@mui/material/TablePagination';
import { findAllLogs } from '../../redux';
import CustomDialog from '../ui/CustomDialog';
import ViewDetails from './ViewDetails';
import { GetTcolumns, GetTsearch, GetTvalues } from './TableData';
import SortTable from '../common/SortTable';
import { format } from 'date-fns';

const initialStateFilter = {
  page: 0,
  pagesize: 10,
  sort: 'logs.createdAt',
  direction: 'DESC',
  requestIp: '',
  logMessage: '',
  createdAt: '',
  actionPerformedBy: ''
}

const initialStateOther = {
  pageLoaded: false,
  modalDiaLogTitle: '',
  modalDiaLogId: false,
  openView: false
}

const reducerFilter = (state, action) => {
  return {
  ...state,
  ...action
  }
}

const LogContainer = (props) => {

  const [state, updateState] = useReducer(reducerFilter, initialStateFilter);
  const [state2, updateState2] = useReducer(reducerFilter, initialStateOther);
  const ui = useSelector((state) => state.ui);
  const log = useSelector((state) => state.log);
  const session = useSelector((state) => state.session);
  const dispatch = useDispatch();

  const setOpen = (open, modalDiaLogId=false, modalDiaLogTitle='', modalName=null) => {
    updateState2({ modalDiaLogId: modalDiaLogId });
    updateState2({ modalDiaLogTitle: modalDiaLogTitle });

    if(modalName !== null) {
      if(modalName === 'VIEW') {
        updateState2({ openView: open });
      }
    } else {
      updateState2({ openView: false });
    }

  }
  const handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    updateState({ [name]: value });

    /* on Selection */
    if(['sort','direction'].includes(name)) {
      updateState({ page: 0 });
      let newFilters = state;
      newFilters[name] = value;
      newFilters['page'] = 0;
      dispatch(findAllLogs(newFilters));
    }

  }
  const handleTableChangePage = (event, newPage) => {
    dispatch(findAllLogs({...state, page: newPage }));
    updateState({ page: newPage });
  }
  const handleTableChangeRowsPerPage = (event) => {
    dispatch(findAllLogs({...state, page: 0, pagesize: parseInt(event.target.value, 10) }));
    updateState({ page: 0, pagesize: parseInt(event.target.value, 10) });
  }
  const onSearchInputEnterKey = () => {
    dispatch(findAllLogs({...state, page: 0}));
    updateState({ page: 0 });
  }
  const handleDateChange = (createdAt) => {
    let formattedDate = '';
    if(createdAt !== null) {
      formattedDate = format(new Date(createdAt), 'yyyy-MM-dd');
    }
    dispatch(findAllLogs({...state, createdAt: formattedDate, page: 0 }));
    updateState({createdAt: formattedDate, page: 0});
  }
  const resetTableSearchInput = () => {
    updateState2({ pageLoaded: false });
  }

  useEffect(() => {
    if(!state2.pageLoaded) {
      updateState(initialStateFilter);
      updateState2({ pageLoaded: true });
      dispatch(findAllLogs(initialStateFilter));
    }
  }, [state2, dispatch]);

  /*** table columns ***/
  const t_data = log.data;
  const t_pagination = log.pagination;

  /*** table fields ***/
  const t_columns = <GetTcolumns openGlobalLoader={ui.openGlobalLoader}
    session={session} />

  /*** table search ***/
  const t_search = <GetTsearch
    onSearchInputEnterKey={onSearchInputEnterKey}
    handleInputChange={handleInputChange}
    handleDateChange={handleDateChange}
    resetTableSearchInput={resetTableSearchInput}
    session={session}
    requestIp={state.requestIp}
    logMessage={state.logMessage}
    createdAt={state.createdAt}
    actionPerformedBy={state.actionPerformedBy}
    />

  /*** table data ***/
  const t_values = <GetTvalues t_data={t_data}
    setOpen={setOpen}
    session={session}
    t_index={state.page * state.pagesize}
    />

  return (
    <main id="main" className="main">
      <PageTitleContainer pageTitle={props.pageTitle} >

      </PageTitleContainer>
      <section className="section">
        <div className="row">

          <CustomDialog title={`View Log ${state2.modalDiaLogTitle ? '- '+state2.modalDiaLogTitle : ''}`} open={state2.openView} setOpen={setOpen} >
            <ViewDetails
              modalDiaLogId={state2.modalDiaLogId}
              setOpen={setOpen}
            />
          </CustomDialog>

        </div>

        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">

                <div className="row mb-1">
                  <div className="col">
                    <div className="float-start">
                      <SortTable sortName={'log'}
                        sort={state.sort}
                        direction={state.direction}
                        handleInputChange={handleInputChange}
                      />
                    </div>
                  </div>

                </div>

                <div className="table-responsive">
                  <table className="table table-hover">
                    <thead>{ t_columns }</thead>
                    <tbody>
                      { t_search }
                      { t_values }
                    </tbody>
                  </table>
                </div>

                <TablePagination
                  component="div"
                  count={t_pagination.itemcount}
                  page={state.page}
                  onPageChange={handleTableChangePage}
                  rowsPerPage={state.pagesize}
                  onRowsPerPageChange={handleTableChangeRowsPerPage}
                  showFirstButton={true}
                  showLastButton={true} />

              </div>
            </div>
          </div>
        </div>

      </section>
    </main>
  )

}


export default LogContainer;
